import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const TestResultSchema = z.object({
  id: z.string().uuid(),
  startTime: z.coerce.date(),
  finishTime: z.coerce.date(),
  isSuccessful: z.boolean(),
  testClass: z.string(),
  failedMethod: z.string().nullable(),
  errorMessage: z.string().nullable(),
  debugOutput: z.string().nullable(),
  stackTrace: z.string().nullable(),
  createdAt: z.coerce.date(),
})

export type TestResult = z.infer<typeof TestResultSchema>

export const TestrunSearchParamsSchema = z
  .object({
    fromDate: z.coerce.date().optional(),
    toDate: z.coerce.date().optional(),
    isFailed: z.boolean().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type TestrunSearchParams = z.infer<typeof TestrunSearchParamsSchema>

export const TestrunSearchResultSchema = z
  .object({
    data: z.array(TestResultSchema),
  })
  .merge(BasePaginateResultSchema)

export type TestrunSearchResult = z.infer<typeof TestrunSearchResultSchema>
